import { CoverageSelectDropdown } from '@/schemas/sceneDataSchema';
import { BaseSelectDropdown } from './BaseSelectDropdown';
import { useCoverageAttribute } from '@/hooks/use-quote';
import { useCallback } from 'react';

export const CoverageSelectDropdownFormElement = ({ component }: { component: CoverageSelectDropdown }) => {
  const { options, getPriceDeltaDescription, findSelectedIndex, handleSelectByIndex } = useCoverageAttribute({
    symbol: component.symbol,
    scope: component.scope,
    kind: component.kind,
  });

  const selectOptions = options.map((opt, idx) => ({
    value: idx.toString(),
    label: opt.label,
    sublabel: getPriceDeltaDescription(opt.label) ?? '',
  }));

  const selectedIndex = findSelectedIndex();

  const handleChange = useCallback(
    (selectedIdx: string) => {
      handleSelectByIndex(parseInt(selectedIdx));
    },
    [handleSelectByIndex]
  );

  return (
    <BaseSelectDropdown
      key={component.kind}
      id={`${component.symbol}-${component.scope}-${component.kind}`}
      label={component.label}
      options={selectOptions}
      selectProps={{
        value: selectedIndex >= 0 ? selectedIndex.toString() : '',
        onChange: (e) => handleChange(e.target.value),
      }}
    />
  );
};
